import { 
    memo, 
    useState 
} from 'react';
import axios from 'axios';

// componentes
import AsyncCreatableSelect from 'react-select/lib/AsyncCreatable';
import OptionSelect from './OptionSelect';

// componente
function ComboAtividades({
    atividades,
    onChange,
    idsGruposAtividades=['1','2']
}) {
    // faz a consulta
    async function consultar(inputValue, callback = null){
        try {

            // faz a requisição
            const { data } = await axios.get(`/atividades`, {
                params: {
                    texto: inputValue,
                    idsGruposAtividades,
                    registrosPorPagina: 7
                }
            });

            // filtra registros, desabilita quem já está na lista
            const registros = data.registros.map(atividadeRegistro => {
                // verifica se já está adicionado
                if(atividades.find(atividadesFind => {
                    if(atividadesFind.id === atividadeRegistro.id){
                        return true;
                    }
                    return false;
                })){
                    atividadeRegistro.isDisabled = true;
                }
                return atividadeRegistro;
            });
            
            if(callback !== null) callback(registros);
        } catch({ response }){
            console.log(response);
        }        
    }

    return (
        <div>
            <AsyncCreatableSelect
                loadOptions={consultar}
                isMulti
                options={atividades}
                value={atividades.map(atividade => {
                    return {
                        label: atividade.nome, 
                        value: atividade.id
                    }
                })}
                components={{ Option: OptionSelect }}
                onChange={(_, validar) => {
                    // verifica ações
                    if(validar.action === 'pop-value') {
                        atividades.pop();
                        onChange([...atividades]);
                    } else if(validar.action === 'remove-value') {
                        // dispara alteração
                        onChange(atividades.filter((atv) => {                            
                            if(atv.id === validar.removedValue.value) {
                                return false;
                            }
                            return true
                        }));
                    } else if(validar.action === 'clear') {
                        onChange([]);
                    } else if(validar.action === 'select-option') {
                        onChange([...atividades, validar.option]);
                    }
                }}
                loadingMessage={() => 'Carregando...'}
                noOptionsMessage={() => 'Digite para encontrar a atividade'}
                placeholder={idsGruposAtividades.length > 1 ? 'Atividades' : `Atividades do grupo ${idsGruposAtividades[0]}`}
            />
        </div>
    )
}

export default memo(ComboAtividades);